import { Action } from '@ngrx/store';

import { ApiStatus, AutomaticPayment } from '@amfam/shared/models';

export interface GetAutoPayPredictionPayload {
  billAccountNumber: string;
  autopayRule: AutoPayRule;
  predictionOnly: boolean;
  transactionId: string;
}

export interface GetAutoPayPredictionResponse {
  status: ApiStatus;
  autoPayRules: AutomaticPayment[];
}

export interface AddEditAutoPayPayload {
  autopayRule: AutoPayRule;
  transactionId: string;
}

export interface AutoPayRule {
  paymentAccountNickName: string;
  daysBeforeDueDate: string;
  paymentAmount: AutoPayAmounts;
}

export interface AddEditAutoPayResponse {
  status: ApiStatus;
  autoPayRules: AutomaticPayment[];
}

export interface AddMultipleAutoPayPayload {
  accounts: {
    billingNumber: string;
    paymentAccountNickName: string;
    daysBeforeDueDate: string;
    paymentAmount: string;
  }[];
}

export interface AddMultipleAutoPayResponse {
  autoPayRules: AutomaticPayment[];
  partialStatuses: {
    payloadEntityId: string; // This is the bill account number
    status: ApiStatus;
  }[];
  status: ApiStatus;
}

export interface DeleteAutoPayPayload {
  action?: {
    payload: DeleteAutoPayPayload;
    correlationId: string;
  } & Action<'[AutoPay] Delete AutoPay'>;
  billAccountNumber: string;
}

export interface DeleteAutoPayResponse {
  status: ApiStatus;
}

export interface GetAutomaticPaymentsPayload {
  billAccountNumber: string;
}

export interface GetAutomaticPaymentsResponse {
  status: ApiStatus;
  autoPayRules: AutomaticPayment[];
}

export interface ApplyAutoPayDiscountPayload {
  FormInstanceTypeAutoPay: {
    policies: {
      policyNumber: string;
      producerId: string;
    }[];
    billAccount: string;
    paymentType: string;
    autoPayIndicator: boolean;
    effectiveDate: string;
    customerId: string;
    partnerId: string;
    templateCode: 'AUTO_PAY_CHANGE';
  };
}

export interface ApplyAutoPayDiscountResponse {
  status: ApiStatus;
}

export enum AutoPayAmounts {
  FULLPAY = 'FULLPAY',
  MINDUE = 'MINDUE'
}
